import React from 'react'
function Card(props) {
    // const [checked, setChecked] = useState(props.active)
    const checked = props.active
    // useEffect(() => {
    //     setChecked(props.active)
    // }, [props.active])
    return (
        <div>
            <div onClick={() => props.onClick()} className={`group hover:bg-primary ${checked ? "bg-primary" : "bg-white"} border border-primary-light rounded-md w-60 2xl:w-83 px-5 pt-2 pb-4 text-center m-2.5 min-h-65 2xl:min-h-90 cursor-pointer`}>
                <img src={props.image} style={{minHeight: props.minHeight ?? 0}} alt={props.title} className={`${props.padded ? "mt-6" : ""} mx-auto 2xl:w-56`} />
                <h2 className={`mt-10 text-xle font-semibold group-hover:text-white ${props.padded ? "mb-4 mt-6" : ""}  ${props.active ? "text-white" : ""}`}>{props.title}</h2>
            </div>
        </div>

    )
}

export default Card
